import {
	createAutoFillFinishedPatch,
	createDonePlatformPatch,
	createErrorPlatformPatch,
	createProcessingPlatformPatch
} from '@/features/FormUploader/helpers/platformHeaderState'
import { patchSelectedPlatform } from '@/store/features/formUploader/formUploaderSlice'
import { useAppDispatch } from '@/store/hooks'
import {
	ISelectedPlatform,
	TPlatformProcessingType,
	TPlatformResult,
	TPlatformValue
} from '@/types/uploadForm.interface'

export const usePlatformHeaderState = (taskId?: string) => {
	const dispatch = useAppDispatch()

	const patchPlatform = (
		value: TPlatformValue,
		patch: Partial<ISelectedPlatform>
	) => {
		if (!taskId) return

		dispatch(patchSelectedPlatform({ taskId, value, patch }))
	}

	const startPlatformProcessing = (
		value: TPlatformValue,
		processing: TPlatformProcessingType
	) => {
		patchPlatform(value, createProcessingPlatformPatch(processing))
	}

	const finishPlatformDone = (
		value: TPlatformValue,
		result: TPlatformResult
	) => {
		patchPlatform(value, createDonePlatformPatch(result))
	}

	const finishPlatformAutoFilled = (value: TPlatformValue) => {
		patchPlatform(value, createAutoFillFinishedPatch())
	}

	const finishPlatformError = (value: TPlatformValue, errorText?: string) => {
		patchPlatform(value, createErrorPlatformPatch(errorText))
	}

	return {
		patchPlatform,
		startPlatformProcessing,
		finishPlatformDone,
		finishPlatformAutoFilled,
		finishPlatformError
	}
}
